import { useEffect } from 'react';

export default function ConfirmActionModal({ open, title, body, costEstimate, confirmLabel, cancelLabel, onConfirm, onCancel, danger }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) {
      if (e.key === 'Escape') onCancel();
      if (e.key === 'Enter') onConfirm();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel, onConfirm]);

  if (!open) return null;

  const accent = danger ? '#C53030' : '#8B1A1A';
  const accentBg = '#FFF5F5';

  return (
    <div onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '12px', padding: '2rem', maxWidth: '460px', width: '90%', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '0.85rem' }}>
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: accentBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h2 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: '#1A1A1A' }}>{title}</h2>
        </div>

        <p style={{ margin: '0 0 1rem', fontSize: '0.9rem', color: '#4A5568', lineHeight: '1.55' }}>
          {body}
        </p>

        {costEstimate && (
          <div style={{ background: '#FAFAF8', borderRadius: '8px', padding: '0.85rem 1rem', marginBottom: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.78rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>
              Estimated cost
            </span>
            <span style={{ fontSize: '1.1rem', fontWeight: '700', color: accent }}>
              {costEstimate}
            </span>
          </div>
        )}

        <div style={{ display: 'flex', gap: '0.6rem' }}>
          <button onClick={onCancel} style={{ flex: 1, padding: '0.7rem', fontSize: '0.85rem', fontWeight: '500', background: '#fff', color: '#4A5568', border: '1px solid #D4CFC9', borderRadius: '6px', cursor: 'pointer' }}>
            {cancelLabel || 'Cancel'}
          </button>
          <button onClick={onConfirm} style={{ flex: 1, padding: '0.7rem', fontSize: '0.85rem', fontWeight: '600', background: accent, color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
            {confirmLabel || 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
